export const PROMO_FETCH_DATA_REQUEST = 'PROMO_FETCH_DATA_REQUEST'
export const PROMO_FETCH_DATA_SUCCESS = 'PROMO_FETCH_DATA_SUCCESS'
export const PROMO_FETCH_DATA_ERROR = 'PROMO_FETCH_DATA_ERROR'
export const SET_PROMO_ID = 'SET_PROMO_ID'
